import MuiSwitch from '@mui/material/Switch'

function Switch(formikProps) {
  const { field, form, ...props } = formikProps

  return <MuiSwitch {...field} {...props} variant="standard" />
}

export default Switch
